var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefund = function SvgRefund(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40.461 6.66602C32.461 6.66602 24.7944 9.49935 18.7944 14.666V9.99935H12.1277V26.666H28.7944V19.9993H22.7944C27.6277 15.666 33.7944 13.3327 40.461 13.3327C55.1277 13.3327 67.1277 25.3327 67.1277 39.9994C67.1277 54.666 55.1277 66.666 40.461 66.666C25.7944 66.666 13.7944 54.666 13.7944 39.9994H7.12769C7.12769 58.3327 22.1277 73.3327 40.461 73.3327C58.7944 73.3327 73.7944 58.3327 73.7944 39.9994C73.7944 21.666 58.7944 6.66602 40.461 6.66602Z",
    fill: "#0A9828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7942 30V50H57.1275V30H23.7942ZM40.4609 43.3333C38.6275 43.3333 37.1275 41.8333 37.1275 40C37.1275 38.1667 38.6275 36.6667 40.4609 36.6667C42.2942 36.6667 43.7942 38.1667 43.7942 40C43.7942 41.8333 42.2942 43.3333 40.4609 43.3333Z",
    fill: "#0A9828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.9609 26L21.7942 34.6667L26.9609 54L59.1275 45.3333L53.9609 26ZM40.4609 43.3333C38.6275 43.3333 37.1275 41.8333 37.1275 40C37.1275 38.1667 38.6275 36.6667 40.4609 36.6667C42.2942 36.6667 43.7942 38.1667 43.7942 40C43.7942 41.8333 42.2942 43.3333 40.4609 43.3333Z",
    fill: "#0A9828"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefund);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "refund.ca38a49df074e2a3262b579dc97ca8d1.svg";